<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Clientes Pre-autorizados</h4>
            </div>
            <div class="card-body">
                <h4 class="card-title">Pre-autorizados</h4>
                <!--
              <form class="form-horizontal">
              </form>
              -->
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>RFC</th>
                                <th>Cliente</th>
                                <th>Estatus Cliente</th>
                                <th>Contrato</th>
                                <th>Abastecimiento</th>
                                <th>Estatus Abastecimiento</th>
                                <th>Sucursal</th>
                                <th>Atendido por</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let cliente of arrayClientes" style="text-align: center">
                                <td (click)="rowSeleccionado(cliente)">{{ cliente.rfc }}</td>
                                <td (click)="rowSeleccionado(cliente)">{{ cliente.clienteFM }}</td>
                                <td (click)="rowSeleccionado(cliente)" style="text-align: left"><span class="label" [style.background]="cliente.clienteEstatus.color"> {{ cliente.clienteEstatus.nombre }} </span></td>
                                <td (click)="rowSeleccionado(cliente)">{{ cliente.noContrato }}</td>
                                <td (click)="rowSeleccionado(cliente)">{{ cliente.concepto }}</td>
                                <td (click)="rowSeleccionado(cliente)" style="text-align: left"><span class="label" [style.background]="cliente.abastecimientoEstatus.color"> {{ cliente.abastecimientoEstatus.nombre }} </span></td>
                                <td (click)="rowSeleccionado(cliente)">{{ cliente.sucursal }}</td>
                                <td (click)="rowSeleccionado(cliente)">{{ cliente.atentido }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/listar-clientes-orden/listar-clientes-orden.component.html